<template>
  <div>
    <div id = "for-getting-default-height">&nbsp;</div>
    <div style="width: 670px" id="ncr-obs-container" class="mb-2">
      <div class="pb-2" id = "ncr-obs-note-title">
        <h6 class="text-center">
          Non-Conformity/Observation Note for {{ $route.params.type.toUpperCase() }}
        </h6>
      </div>


      <table class="ap-tbl">
        <colgroup>
          <col style="width: 40px !important;">
          <col style="width: 90px !important;">
          <col style="width: 217.5px !important;">
          <col style="width: 217.5px !important;">
          <col style="width: 105px !important;">
        </colgroup>
        <tbody>
        <template v-for="(data, index) in nonConformityType[$route.params.type]">
          <tr class="text-center" :id="`ncr_header_${index}`">
            <td>No</td>
            <td>{{ index + 1 }}</td>
            <td colspan="2">
              (NCR/<s>OBS</s>)
            </td>
            <td>
              Ref to SMS/
              Regulator
            </td>
          </tr>
          <tr>
            <td colspan="4" :id="`ncr_description_part_${index}`" class="description-oe-content">
              <p>Description</p>
              <p v-html="data.description"></p>
              <p><br></p>
              <p v-if="data.objective_evidences.length > 0">Objective Evidences:</p>

              <template v-for="(oe, oe_index) in data.objective_evidences">
                <p> (O.E. {{ oe_index + 1 }})</p>
                <p v-html="oe.decoded_description"></p>
                <p v-if="oe.rectified === 1"><span style="color: red">Rectified on the spot.</span></p>
                <p><br></p>
              </template>

              <p v-if="data.root_cause.length > 0">Root Cause:</p>
              <template v-for="cause in data.root_cause">
                <p v-html="cause.name"></p>
              </template>
              <p><br></p>

              <p v-if="data.objective_evidences.length > 0">Corrective action request:</p>

              <template v-for="(oe, oe_index) in data.objective_evidences">
                <p> (For {{ oe_index + 1 }})</p>
                <p v-html="oe.decoded_ca_request"></p>
              </template>
              <p><br></p>

            </td>
            <td class="oe-reference-content">
              <template v-for="(oe, oe_index) in data.objective_evidences">
                <p> (For {{ oe_index + 1 }})</p>
                <p v-html="oe.reference"></p>
                <hr>
              </template>
            </td>
          </tr>
          <tr :id = "`ncr_oe_recurrence_ashore_header_part_${index}`">
            <td rowspan="2" colspan="2" class="oe-recurrence-ashore">Prevention of
              Recurrence ashore
            </td>
            <td>
              <table class="m-1 w-100">
                <tr>
                  <td style="border: none; width: 174px" class="text-center">
                    Training Needed
                  </td>
                  <td v-if="data.training_need === 1">X</td>
                  <td v-else>X</td>
                </tr>
              </table>
            </td>
            <td>
              <table class="m-1 w-100">
                <tr>
                  <td style="border: none; width: 174px" class="text-center">
                    Change of procedures
                  </td>
                  <td v-if="data.change_of_procedures === 1">X</td>
                  <td v-else>X</td>
                </tr>
              </table>
            </td>
            <td rowspan="2"></td>
          </tr>
          <tr>
            <td colspan="2" v-if="data.decoded_recurrence_ashore.trim() !== ''" v-html="data.decoded_recurrence_ashore" :id="`ncr_oe_recurrence_ashore_part_${index}`"></td>
            <td colspan="2" v-else :id="`ncr_oe_recurrence_ashore_part_${index}`"><p><br></p></td>
          </tr>
          <tr>
            <td colspan="2" :id = "`ncr_prevention_on_site_left_title_${index}`" class="oe-recurrence-onsite">Prevention of
              Recurrence on site
            </td>
            <td colspan="2" v-if="data.decoded_recurrence_on_site.trim() !== ''" v-html="data.decoded_recurrence_on_site" :id="`ncr_oe_recurrence_onsite_part_${index}`"></td>
            <td colspan="2" v-else :id="`ncr_oe_recurrence_onsite_part_${index}`"><p><br></p></td>
            <td></td>
          </tr>
        </template>
        <template v-for="(data, index) in observationNoteType[$route.params.type]">
          <tr class="text-center" :id="`obs_header_${index}`">
            <td>No</td>
            <td>{{ index + 1 }}</td>
            <td colspan="2">
              (<s>NCR</s>/OBS)
            </td>
            <td>
              Ref to SMS/
              Regulator
            </td>
          </tr>
          <tr>
            <td colspan="4" :id="`obs_description_part_${index}`" class="description-oe-content">
              <p>Description</p>
              <p v-html="data.description"></p>
              <p><br></p>
              <p v-if="data.objective_evidences.length > 0">Objective Evidences:</p>

              <template v-for="(oe, oe_index) in data.objective_evidences">
                <p> (O.E. {{ oe_index + 1 }})</p>
                <p v-html="oe.decoded_description"></p>
                <p v-if="oe.rectified === 1"><span style="color: red">Rectified on the spot.</span></p>
                <p><br></p>
              </template>

              <p v-if="data.root_cause.length > 0">Root Cause:</p>
              <template v-for="cause in data.root_cause">
                <p v-html="cause.name"></p>
              </template>
              <p><br></p>

              <p v-if="data.objective_evidences.length > 0">Corrective action request:</p>

              <template v-for="(oe, oe_index) in data.objective_evidences">
                <p> (For {{ oe_index + 1 }})</p>
                <p v-html="oe.decoded_ca_request"></p>
              </template>
              <p><br></p>

            </td>
            <td class="oe-reference-content">
              <template v-for="(oe, oe_index) in data.objective_evidences">
                <p> (For {{ oe_index + 1 }})</p>
                <p v-html="oe.reference"></p>
                <hr>
              </template>
            </td>
          </tr>
          <tr :id = "`obs_oe_recurrence_ashore_header_part_${index}`">
            <td rowspan="2" colspan="2" class="oe-recurrence-ashore">Prevention of
              Recurrence ashore
            </td>
            <td>
              <table class="m-1 w-100">
                <tr>
                  <td style="border: none; width: 174px" class="text-center">
                    Training Needed
                  </td>
                  <td v-if="data.training_need === 1">X</td>
                  <td v-else>X</td>
                </tr>
              </table>
            </td>
            <td>
              <table class="m-1 w-100">
                <tr>
                  <td style="border: none; width: 174px" class="text-center">
                    Change of procedures
                  </td>
                  <td v-if="data.change_of_procedures === 1">X</td>
                  <td v-else>X</td>
                </tr>
              </table>
            </td>
            <td rowspan="2"></td>
          </tr>
          <tr>
            <td colspan="2" v-if="data.decoded_recurrence_ashore.trim() !== ''" v-html="data.decoded_recurrence_ashore" :id="`obs_oe_recurrence_ashore_part_${index}`"></td>
            <td colspan="2" v-else :id="`obs_oe_recurrence_ashore_part_${index}`"><p><br></p></td>
          </tr>
          <tr>
            <td colspan="2" :id = "`obs_prevention_on_site_left_title_${index}`" class="oe-recurrence-onsite">Prevention of
              Recurrence on site
            </td>
            <td colspan="2" v-if="data.decoded_recurrence_on_site.trim() !== ''" v-html="data.decoded_recurrence_on_site" :id="`obs_oe_recurrence_onsite_part_${index}`"></td>
            <td colspan="2" v-else :id="`obs_oe_recurrence_onsite_part_${index}`"><p><br></p></td>
            <td></td>
          </tr>
        </template>

        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
export default {
  name: 'NcrObsPdfDocument',
  data() {
    return {
      defaultHeight: null,
      heightPerPages: [0],
      maxHeightPerPage: 954
    }
  },
  methods: {
    ...mapActions([
      'getNonConformities',
    ]),
    getAllContent(element) {
      let allChildren = [];
      const elementChildren = $(element).children();

      for (let childCounter = 0; childCounter < elementChildren.length; childCounter++) {
        const childElement = elementChildren[childCounter];
        const childChildrenElements = $(childElement).children();

        if (childChildrenElements.length === 0) {
          allChildren.push({
            element: childElement,
            height: parseFloat($(childElement).is('br') ? 17.3 : $(childElement).height())
          });
        } else {
          for (let grandChildCounter = 0; grandChildCounter < childChildrenElements.length; grandChildCounter++) {
            allChildren.push({
              element: childChildrenElements[grandChildCounter],
              height: parseFloat($(childChildrenElements[grandChildCounter]).is('br') ? 17.3 : $(childChildrenElements[grandChildCounter]).height())
            });
          }
        }
      }

      return allChildren;
    },
    preparePageHeights(data, type) {
      data.forEach((ncr_data, index) => {
        let currentHeight = this.getCurrentHeight();
        // computing all heights for main and oe description part content
        const ncrHeaderHeight = $(`#${type}_header_${index}`).outerHeight();
        if ((currentHeight + ncrHeaderHeight ) <= this.maxHeightPerPage) {
          this.heightPerPages[this.heightPerPages.length - 1] += ncrHeaderHeight;
        } else {
          this.heightPerPages.push(ncrHeaderHeight);
        }

        const descriptionPartElement = $(`#${type}_description_part_${index}`);
        const allDescriptionContentTotalHeight = descriptionPartElement.outerHeight();

        this.setHeightPerPages(allDescriptionContentTotalHeight)

        // computing all heights for prevention recurrence ashore
        const recurrenceAshoreTableHeight = $(`#${type}_oe_recurrence_ashore_header_part_${index}`).outerHeight();
        let recurrenceAshoreMinHeight = this.defaultHeight + 1;

        const recurrenceAshoreHeaderHeight = recurrenceAshoreTableHeight + recurrenceAshoreMinHeight;

        currentHeight = this.getCurrentHeight();

        if ((currentHeight + recurrenceAshoreHeaderHeight) <= this.maxHeightPerPage) {
          this.heightPerPages[this.heightPerPages.length - 1] += recurrenceAshoreHeaderHeight;
        } else {
          this.heightPerPages.push(recurrenceAshoreHeaderHeight);
        }

        let allRecurrenceAshoreContentTotalHeight = $(`#${type}_oe_recurrence_ashore_part_${index}`).outerHeight();
        if (allRecurrenceAshoreContentTotalHeight >= recurrenceAshoreMinHeight) {
          allRecurrenceAshoreContentTotalHeight = allRecurrenceAshoreContentTotalHeight - recurrenceAshoreMinHeight;
        }

        this.setHeightPerPages(allRecurrenceAshoreContentTotalHeight)
        // computing all heights for prevention recurrence onsite
        let allRecurrenceOnSiteContentTotalHeight = $(`#${type}_oe_recurrence_onsite_part_${index}`).outerHeight();

        this.setHeightPerPages(allRecurrenceOnSiteContentTotalHeight)

      })
    },
    getHeightPerPages() {
      this.heightPerPages[this.heightPerPages.length - 1] = this.maxHeightPerPage;
      return this.heightPerPages;
    },
    getCurrentHeight() {
      return this.heightPerPages[this.heightPerPages.length - 1];
    },
    setHeightPerPages(totalHeight) {
      const division = totalHeight / this.defaultHeight;
      const totalFromDefaultHeight = Math.trunc(division);

      let currentHeight = this.getCurrentHeight();

      for (let counter = 0; counter < totalFromDefaultHeight; counter++) {
        currentHeight = this.getCurrentHeight();

        if ((currentHeight + this.defaultHeight) <= this.maxHeightPerPage) {
          this.heightPerPages[this.heightPerPages.length - 1] += this.defaultHeight;
        } else {
          this.heightPerPages.push(this.defaultHeight);
        }
      }

      const remainderFromTotalHeight = division % 1;
      const heightRemainder = remainderFromTotalHeight * this.defaultHeight;
      currentHeight = this.getCurrentHeight();

      if ((currentHeight + heightRemainder) <= this.maxHeightPerPage) {
        this.heightPerPages[this.heightPerPages.length - 1] += heightRemainder;
      } else {
        this.heightPerPages.push(heightRemainder);
      }
    },
    async prepareHtmlContent() {
      await this.getNonConformities({
        id: this.selectedAuditRecord[this.$route.params.type].id,
        type: this.$route.params.type
      });

      const ncrData = this.nonConformityType[this.$route.params.type];
      const obsData = this.observationNoteType[this.$route.params.type];
      this.heightPerPages = [$('#ncr-obs-note-title').outerHeight()];
      this.preparePageHeights(ncrData, 'ncr');
      this.preparePageHeights(obsData, 'obs');

    },
    getHtmlContent() {
      return $('#ncr-obs-container')[0].outerHTML;
    }
  },
  async mounted() {
    this.defaultHeight = $('#for-getting-default-height').height();
  },
  computed: {
    ...mapGetters([
      'selectedAuditRecord',
      'nonConformityType',
      'observationNoteType',
    ]),
  }
}
</script>
